module.exports = __webpack_public_path__ + "img/linovel.66f52456.svg";